import { profile } from "../data/profile";

export function renderAbout(mount: HTMLElement): void {
  const section = document.createElement("section");
  section.className = "page-section";

  const eyebrow = document.createElement("p");
  eyebrow.className = "page-eyebrow";
  eyebrow.textContent = "About";

  const title = document.createElement("h2");
  title.className = "page-title";
  for (const [i, ch] of Array.from("はじめまして").entries()) {
    const span = document.createElement("span");
    span.className = "page-title-char";
    span.textContent = ch;
    span.style.setProperty("--char-i", String(i));
    title.append(span);
  }

  const leadGroup = document.createElement("div");
  leadGroup.className = "page-lead-group";
  for (const para of profile.bio) {
    const p = document.createElement("p");
    p.className = "page-lead";
    p.textContent = para;
    leadGroup.append(p);
  }

  const divider = document.createElement("hr");
  divider.className = "page-divider";

  const grid = document.createElement("dl");
  grid.className = "about-grid";

  // Identity row: kanji with kana ruby on top, then en after a slash.
  const nameDt = document.createElement("dt");
  nameDt.textContent = "氏名";
  grid.append(nameDt);

  const nameDd = document.createElement("dd");
  const ruby = document.createElement("ruby");
  ruby.append(profile.name.ja);
  const rt = document.createElement("rt");
  rt.textContent = profile.name.kana;
  ruby.append(rt);
  nameDd.append(ruby, ` / ${profile.name.en}`);
  grid.append(nameDd);

  const rows: Array<[string, string | string[]]> = [
    ["役職", profile.role],
    ["所属", profile.affiliation],
    ["拠点", profile.location],
    ["生年", String(profile.yearOfBirth)],
    ["経歴", profile.history.map((h) => `${h.year} — ${h.description}`)],
    ["スキル", profile.skills],
  ];

  for (const [key, value] of rows) {
    const dt = document.createElement("dt");
    dt.textContent = key;
    grid.append(dt);

    const dd = document.createElement("dd");
    if (Array.isArray(value)) {
      const ul = document.createElement("ul");
      for (const item of value) {
        const li = document.createElement("li");
        li.textContent = item;
        ul.append(li);
      }
      dd.append(ul);
    } else {
      dd.textContent = value;
    }
    grid.append(dd);
  }

  section.append(eyebrow, title, leadGroup, divider, grid);
  mount.append(section);
}
